'use strict';

var FaresSurchargeUploadImportModalController = function FaresSurchargeUploadImportModalController($scope, $q, importService, featureToggleService) {
  var VALID_CLASS = 'valid';
  var INVALID_CLASS = 'invalid';
  var MAX_FILE_SIZE_IN_BYTES = 1024 * 1024 * 20;
  $scope.chosenFileName = '';
  $scope.chosenFile = null;
  $scope.importedRowsStatus = '';
  $scope.importStatus = '';
  $scope.isUploadInProgress = false;
  $scope.stateToBeRestored = {
    chosenFile: null,
    chosenFileName: ''
  };
  $scope.helpMessage = '';
  $scope.fimMessage = '';
  if (featureToggleService.isEnabled('FIM') && featureToggleService.isEnabled('SPOS')) {
    $scope.helpMessage += '&emsp;&emsp;f. POS – Not Empty<br/>' + '&emsp;&emsp;g. Surcharge – Non-negative numeric values<br/>';
    $scope.fimMessage = 'The surcharges uploaded by users will be applied to fares the next time fares are processed by the Fares Integration Manager.</br>';
  } else {
    $scope.helpMessage += '&emsp;&emsp;f. Surcharge – Non-negative numeric values<br/>';
  }
  function isImportValid(invalidRowsNumber) {
    return invalidRowsNumber === 0;
  }
  function saveCurrentState() {
    $scope.stateToBeRestored.chosenFile = $scope.chosenFile;
    $scope.stateToBeRestored.chosenFileName = $scope.chosenFileName;
  }
  function restorePreviousModalState() {
    $scope.chosenFile = $scope.stateToBeRestored.chosenFile;
    $scope.chosenFileName = $scope.stateToBeRestored.chosenFileName;
  }
  function setUpImportNotification(invalidRows, allRows) {
    var invalidRowsNumber = invalidRows.length;
    if (isImportValid(invalidRowsNumber)) {
      $scope.importStatus = VALID_CLASS;
      $scope.importedRowsStatus = '' + allRows.length + ' records were imported successfully';
    } else {
      $scope.errorLogData = importService.setUpImportErrorLogData(allRows);
      $scope.isImportValidationError = true;
      $scope.importedRowsStatus = '' + allRows.length + ' records were imported with ' + invalidRowsNumber + ' errors';
      $scope.importStatus = INVALID_CLASS;
    }
    $scope.isUploadInProgress = false;
    saveCurrentState();
  }
  function getDataAndSetUpNotifications(response) {
    var allRows = response.value;
    var invalidRows = importService.findInvalidRows(allRows);
    setUpImportNotification(invalidRows, allRows);
  }
  function handleServerImportError() {
    $scope.isUploadInProgress = false;
  }
  function setScopeAtUploadStart() {
    $scope.importedRowsStatus = '';
    $scope.importStatus = '';
    $scope.isImportValidationError = false;
    $scope.isUploadInProgress = true;
  }
  $scope.uploadSurcharges = function () {
    setScopeAtUploadStart();
    importService.importMarketClassSurcharges($scope.chosenFile).then(getDataAndSetUpNotifications, handleServerImportError);
  };
  function reloadGridDataIfImportSuccessful() {
    if ($scope.importStatus === VALID_CLASS) {
      $scope.$broadcast('grid:dataChanged');
    }
  }
  $scope.handleModalHide = function () {
    reloadGridDataIfImportSuccessful();
  };
  $scope.handleModalHideAndResetItsState = function () {
    reloadGridDataIfImportSuccessful();
    restorePreviousModalState();
  };
  $scope.showErrorLog = function ($event) {
    $event.preventDefault();
    $scope.isErrorLogShown = true;
  };
  $scope.isUploadButtonDisabled = function () {
    return !$scope.chosenFileName || $scope.isUploadInProgress || $scope.chosenFile.size > MAX_FILE_SIZE_IN_BYTES;
  };
  $scope.hideErrorLog = function () {
    $scope.isErrorLogShown = false;
    $scope.$broadcast('fares-surcharge-upload-grid:showImportModal');
  };
};
FaresSurchargeUploadImportModalController.$inject = ['$scope', '$q', 'FaresSurchargeUploadImportService', 'FeatureToggleService'];
module.exports = FaresSurchargeUploadImportModalController;